import React, { useState, useEffect } from 'react'

const SessionExpirationModal = ({ isOpen, timeRemaining, onRenew, onLogout, loading }) => {
    if (!isOpen || !timeRemaining) return null;

    const minutes = Math.max(0, Math.floor(timeRemaining / 60000));
    const seconds = Math.max(0, Math.floor((timeRemaining % 60000) / 1000));

    return (
        <div className="fixed inset-0 bg-black/50 dark:bg-black/70 z-[9999] flex items-center justify-center pointer-events-auto" style={{pointerEvents: 'auto'}}>
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-8 max-w-md w-full mx-4 border border-red-200 dark:border-red-800 animate-in fade-in scale-95" style={{animationDuration: '200ms'}}>
                <div className="flex items-start gap-3 mb-4">
                    <span className="material-icons text-red-500 dark:text-red-400 text-2xl flex-shrink-0">warning</span>
                    <h2 className="text-xl font-bold text-gray-900 dark:text-white">Sessão Expirando</h2>
                </div>

                <p className="text-gray-600 dark:text-gray-400 mb-6">
                    Sua sessão expirará em <strong className="text-red-500 dark:text-red-400">{minutes}m {seconds}s</strong>.
                    Para continuar trabalhando, renove sua sessão ou faça login novamente.
                </p>

                <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3 mb-6">
                    <div className="flex gap-2">
                        <span className="material-icons text-yellow-600 dark:text-yellow-400 flex-shrink-0" style={{fontSize: '16px'}}>info</span>
                        <p className="text-xs text-yellow-800 dark:text-yellow-300">
                            <strong>Dica:</strong> Sua sessão será renovada com um novo token por mais 30 minutos.
                        </p>
                    </div>
                </div>

                <div className="flex gap-3">
                    <button
                        onClick={onRenew}
                        disabled={loading}
                        className="flex-1 bg-blue-500 hover:bg-blue-600 disabled:bg-blue-400 text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center gap-2"
                    >
                        <span className="material-icons sm">refresh</span>
                        Renovar Sessão
                    </button>
                    <button
                        onClick={onLogout}
                        disabled={loading}
                        className="flex-1 bg-gray-300 dark:bg-gray-600 hover:bg-gray-400 dark:hover:bg-gray-700 disabled:bg-gray-200 dark:disabled:bg-gray-700 text-gray-900 dark:text-white font-medium py-2 px-4 rounded-lg transition flex items-center justify-center gap-2"
                    >
                        <span className="material-icons sm">logout</span>
                        Sair
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionExpirationModal
